import Vue from 'vue'
import Vuex from 'vuex'
// import { stat } from 'fs';
// import firebase from 'firebase'

Vue.use(Vuex)
// 1624

export default new Vuex.Store({
    state: {
        //server vars
        pageSetup: null,
        indexPage: null,
        aboutPage: null,
        newsPage: null,
        contactsPage: null,
        activityPage: null,
        activityItemsCarousel: null,
        // VACANCY
        vacancyPage: null,
        VacancyItems: null,
        VacancyItemsFilter: null,
        VacancyContacts: null,
        //news vars
        newsItems: [],
        newsItemsDefault: [],
        newsItemsFilter: [],
        newsCardAnimate: true,
        newsPageCount: 1,
        // VIDEO 
        videoPage: null,
        videoItems: [],
        videoItemsDefault: [],
        videoItemsFilter: [],
        videoCardAnimate: true,
        videPageCount: 1,
        videoHidePaginBtn: false,
        videoItemsSafety: [],
        //components vars
        promoCarouselItems: null,

        projectsPage: null,
        partnersPage: null,
        politicsPage: null,
        generationPage: null,
        valuablePage: null,
        constructionPage: null,
        developmentPage: null,
        engineeringPage: null,
        explotationPage: null,
        productionPage: null,
        rentPage: null,
        //Contacts page
        contactsSales: null,
        contactsCardAnimate: true,
        contactsMapCoords: [],
        pinCoords: {
            lat: null,
            lng: null,
        },
        //sales vars
        projectItems: null,
        projectItemsFilterData: {
            filter_slug: 'all',
            filter_id: null,
        },
        projectItemsCounter: {
            count_max: 1,
            count_current: 1,
        },

        cardAnimate: true,
        howItWorksData: null,
        // project vars
        currentCity: null,
        currentCityArr: null,
        breadCrumbInit: null,
        customCrumbGlobalVar: null,
        pageName: null,
        hidePaginBtn: false,
        forms: null,
        // MOBILE VARS
        isOpenSendwich: false,
        isOpenFormConsult: false,
        isOpenFormSignUpProject: false,
        isMobileChecker: false,
        formConsultData: null,
        titleSite: 'BAZIS-A - один из крупных застройщиков Казахстана. ENJOY LIFE!',
    },
    getters: {
        // server getters
        loadPageSetUp: state => state.pageSetup,
        loadIndexPage: state => state.indexPage,
        loadAboutPage: state => state.aboutPage,
        loadActivityPage: state => state.activityPage,
        loadActivityItemsCarousel: state => state.activityItemsCarousel,
        // loadNewsPage: state => state.newsPage,
        //news getters
        loadNewsItems: state => state.newsItems,
        loadNewsItemsDefault: state => state.newsItemsDefault,
        loadNewsItemsFilter: state => state.newsItemsFilter,
        loadNewsCardAnimateStatus: state => state.newsCardAnimate,
        loadNewsPageCount: state => state.newsPageCount,
        //CONTACTS PAGE
        loadContactsPage: state => state.contactsPage,
        loadContactsSales: state => state.contactsSales,
        loadContactsCardAnimate: state => state.contactsCardAnimate,
        loadContactsMapCoords: state => state.contactsMapCoords,
        // VACANCY PAGE
        loadVacancyPage: state => state.vacancyPage,
        loadVacancyItems: state => state.VacancyItems,
        loadVacancyItemsDefault: state => state.VacancyItemsFilter,
        loadVacancyContacts: state => state.VacancyContacts,
        // video getters
        loadVideoPage: state => state.videoPage,
        loadVideoItems: state => state.videoItems,
        loadVideoItemsDefault: state => state.videoItemsDefault,
        loadVideoItemsFilter: state => state.videoItemsFilter,
        loadVideoCardAnimateStatus: state => state.videoCardAnimate,
        loadVideoPageCount: state => state.videoPageCount,
        loadHidePaginBtnVideo: state => state.videoHidePaginBtn,
        loadVideoItemsSafety: state => state.videoItemsSafety,
        // components getters
        loadPromoCarouselItems: state => state.promoCarouselItems,
        //projects getters
        loadProjectsPage: state => state.projectsPage,
        loadProjectItems: state => state.projectItems,
        loadProjectItemsCounter: state => state.projectItemsCounter,
        loadProjectFilterData: state => state.projectItemsFilterData,

        loadIsMobileChecker: state => state.isMobileChecker,
        loadCardAnimateStatus: state => state.cardAnimate,
        loadHowItWorks: state => state.howItWorksData,
        // custom getters
        loadCurrentCity: state => state.currentCity,
        loadCurrentCityArr: state => state.currentCityArr,
        loadBreadCrumbInit: state => state.breadCrumbInit,
        loadCustomCrumbGlobal: state => state.customCrumbGlobalVar,
        loadPageName: state => state.pageName,
        loadFavoriteCount: state => state.favoriteCount,
        loadHidePaginBtn: state => state.hidePaginBtn,
        loadForms: state => state.forms,
        // Mobile getters
        loadOpenSendwich: state => state.isOpenSendwich,
        loadOpenFormConsult: state => state.isOpenFormConsult,
        loadOpenFormSignUpProject: state => state.isOpenFormSignUpProject,
        loadFormConsultData: state => state.formConsultData,
        loadSiteTitle: state => state.titleSite,
    },
    actions: {
        /// PROJECT ACTIONS
        getPageSetUp({commit}) {
            if (this.state.pageSetup == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'settings/254').then(async (response) => {
                        // console.log(response.data.acf, 'SETUP')
                        commit('PageSetUp', response.data.acf)
                        resolve('complete');
                    });
                });
            }
        },
        getIndexPageData({commit}) {
            if (this.state.indexPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/247').then(async (response) => {
                        // console.log(response.data.acf, 'INDEX PAGE');
                        commit('indexPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getAboutPageData({commit}) {
            if (this.state.aboutPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1624').then(async (response) => {
                        console.log(response.data.acf, 'ABOUT');
                        commit('aboutPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getContactsPageData({commit}) {
            if (this.state.contactsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/291').then(async (response) => {
                        // console.log(response.data.acf, 'CONTACTS');
                        commit('contactsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getVacancyPage({commit}) {
            if (this.state.vacancyPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/2043').then(async (response) => {
                        // console.log(response.data.acf, 'vacancyPage');
                        commit('vacancyPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getActivityPage({commit}) {
            if (this.state.activityPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1630').then(async (response) => {
                        console.log(response.data.acf, 'activityPage');
                        commit('ActivityPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsPageData({commit}) {
            if (this.state.newsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/249').then(async (response) => {
                        // console.log(response.data.acf, 'NEWS PAGE');
                        commit('newsPage', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        getNewsItems({commit}) {
            if (this.state.newsItems.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news/?start_date=2020-01-01&per_page=9').then(async (response) => {
                        // console.log(response, 'NEWS ITEMS')
                        commit('newsItems', response.data);
                        commit('newsCountOfPages', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },
        getVideoPage({commit}) {
            if (this.state.videoPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.urlSales + window.GlobalLang + window.JsonUrl + 'pages/1956').then(async (response) => {
                        // console.log(response.data.acf, 'SETUP')
                        commit('videoPage', response.data.acf)
                        resolve('complete');
                    });
                });
            }
        },
        getVideoItems({commit}) {
            if (this.state.videoItems.length == 0) {
                return new Promise((resolve, reject) => {
                    axios.get(window.urlSales + window.GlobalLang + '/wp-json/wp/v2/video/?start_date=2020-01-01&per_page=9').then(async (response) => {
                        // console.log(response.data, 'VIDEO')
                        commit('videoItems', response.data);
                        commit('videoPageCount', parseFloat(response.headers['x-wp-totalpages']))
                        resolve('complete');
                        // console.log(response);
                    });
                });
            }
        },

        getActivityCarouselItemsByIDs({commit}, payload) {
            if (this.state.activityItemsCarousel == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/built?include=' + payload).then(async (response) => {
                        console.log(response, 'activiity ITEMs');
                        commit('ActivityCarouselItems', response.data);
                        resolve('complete');
                    });
                });
            }
        },

        // COMPONENTS ACTIONS
        getPromoItemsByIDs({commit}, payload) {
            if (this.state.promoCarouselItems == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/built?include=' + payload).then(async (response) => {
                        // console.log(response, 'carousel promo ITEMs');
                        commit('promoCarouselItemsSet', response.data.reverse());
                        resolve('complete');
                    });
                });
            }
        },

        getProjectsPage({commit}) {
            if (this.state.projectsPage == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/1644').then(async (response) => {
                        // console.log(response);
                        commit('projectsPageData', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // PAGE PROJECT BUILT/CONST/INT/PROMIS
        getProjectItemsList({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/' + payload + '/?per_page=9').then(async (response) => {
                    // console.log(response, 'BUILT ITEMS');
                    commit('projectItems', response.data);
                    commit('projectItemsCountOfPages', parseFloat(response.headers['x-wp-totalpages']));
                    resolve('complete');
                });
            });
        },
        getProjectItemsByParam({commit}, payload) {
            // console.log(payload, '77777')
            return new Promise((resolve, reject) => {
                axios.get(window.url + window.GlobalLang + 'wp-json/wp/v2/' + payload.url).then(async (response) => {
                    // console.log(response, 'filter ITEMS');
                    if (payload.type == 'filter') {
                        commit('projectItems', response.data);
                        commit('projectItemsCountOfPages', parseFloat(response.headers['x-wp-totalpages']));
                    } else {
                        commit('projectItemsUpdate', response.data);
                    }
                    resolve('complete');
                });
            });
        },
        getFormsData({commit}) {
            if (this.state.forms == null) {
                return new Promise((resolve, reject) => {
                    axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages/253').then(async (response) => {
                        // console.log(response.data.acf, 'FORMS');
                        commit('formsData', response.data.acf);
                        resolve('complete');
                    });
                });
            }
        },
        // REQUEST FROM PORTAL.BAZIS.KZ
        getDataFromPortalBazis({commit}) {
            axios.get('https://portal.bazis.kz/cms/' + window.GlobalLang + window.JsonUrl + 'pages/45').then(async (response) => {
                // console.log(response.data.acf, 'portal data');
                commit('howItWorksDataSet', response.data.acf);
            });
        }
    },
    mutations: {
        howItWorksDataSet(state, data) {
            state.howItWorksData = data
        },
        promoCarouselItemsSet(state, data) {
            state.promoCarouselItems = data
        },
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        indexPage(state, data) {
            state.indexPage = data
        },
        aboutPage(state, data) {
            state.aboutPage = data
        },
        projectsPageData(state, data) {
            state.projectsPage = data
        },
        newsPage(state, data) {
            state.newsPage = data
        },
        vacancyPage(state, data) {
            state.vacancyPage = data
        },
        ActivityPage(state, data) {
            state.activityPage = data;
        },
        ActivityCarouselItems(state, data) {
            state.activityItemsCarousel = data
        },
        //contacts page
        contactsPage(state, data) {
            state.contactsPage = data
        },
        setContactsCardAnimation(state, data) {
            state.contactsCardAnimate = data
        },
        //SALES MUTATIONS
        projectItems(state, data) {
            state.projectItems = [];
            // state.builtItemsDefault = [];
            for (var i = 0; i < data.length; i++) {
                state.projectItems.push(data[i]);
                // state.builtItemsDefault.push(data[i]);
            }
        },
        projectItemsUpdate(state, data) {
            for (var i = 0; i < data.length; i++) {
                state.projectItems.push(data[i]);
                // state.builtItemsDefault.push(data[i]);
            }
        },
        projectItemsCountOfPages(state, data) {
            state.projectItemsCounter.count_max = data;
            state.projectItemsCounter.count_current = 1
            // console.log(data, 'counter')
        },
        projectItemsSetCountDef(state, data) {
            state.projectItemsCounter.count_current = data
        },
        projectFilterDataSet(state, data) {
            state.projectItemsFilterData.filter_slug = data.slug;
            state.projectItemsFilterData.filter_id = data.id;
        },
        //PROJECTS PAGE MUTATIONS ////////////////////////////////////////////////////////////////////////////////////////////
        setMobileCheckerState(state, data) {
            state.isMobileChecker = data
        },
        // END PROJECT PAGE MUTATIONS
        filterVacancyItems(state, data) {
            state.VacancyItems = data
        },  
        filterVacancyContacts(state, data) {
            state.VacancyContacts = data
        },
        filterProjectsItems(state, data) {
            state.projectItems = data;
        },
        cardAnimateSet(state, data) {
            state.cardAnimate = data
        },
        filterMapCoords(state, data) {
            state.mapCoords = data
        },
        salesCardPageIDset(state, data) {
            state.salesCardPageID = data;
        },
        //news MUTATIONS
        newsItems(state, data) {
            state.newsItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.newsItems.push(items[i]);
                state.newsItemsDefault.push(items[i]);
                state.newsItemsFilter.push(items[i]);
            }
            // console.log(items, 'IETMS SUKA')
            // console.log(state.newsItems, 'ITEMS BUGAA')
            // state.projectItems = data;
        },
        newsPaginate(state, data) {
            // console.log(data);
            // state.newsItems = data;
        },
        filterNewsItems(state, data) {
            state.newsItems = data;
        },
        newsCardAnimateSet(state, data) {
            state.newsCardAnimate = data
        },
        newsCountOfPages(state, data) {
            state.newsPageCount = data
        },
        // NEWS MUTATIONS
        //Video mutations
        videoPage(state, data) {
            state.videoPage = data
        },
        videoItems(state, data) {
            state.videoItems = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItems.push(items[i]);
                state.videoItemsDefault.push(items[i]);
                state.videoItemsFilter.push(items[i]);
            }
        },
        videoItemsPaginateAdd(state, data) {
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItems.push(items[i]);
                state.videoItemsDefault.push(items[i]);
                state.videoItemsFilter.push(items[i]);
            }
        },
        videoPageCount(state, data) {
            state.videoPageCount = data
        },
        videoHidePaginate(state, data) {
            state.videoHidePaginBtn = data
        },
        videoItemsSafety(state, data) {
            state.videoItemsSafety = [];
            var items = [];
            // console.log(data, 'news mutations');
            var i;
            for (i =0; i < data.length; i++) {
                items.push(data[i].acf)
            }
            for (i = 0; i < data.length; i++) {
                Object.assign(items[i], {
                    'id': data[i].id,
                    'slug': data[i].slug,
                    'date': data[i].date,
                });
            }
            for (i=0; i < items.length; i ++) {
                state.videoItemsSafety.push(items[i]);
            }
        },
        filterVideoItems(state, data) {
            state.videoItems = data;
        },
        videoCardAnimateSet(state, data) {
            state.videoCardAnimate = data
        },
        // project mutations
        CurrentCity(state, data) {
            state.currentCity = data
        },
        CurrentCityArr(state, data) {
            state.currentCityArr = data
        },
        breadCrumbInt(state, data) {
            state.breadCrumbInit = data
        },
        setCustomCrumb(state, data) {
            state.customCrumbGlobalVar = data
        },
        setPageName(state, data) {
            state.pageName = null;
            state.pageName = data;
        },
        setFavoriteCount(state, data) {
            state.favoriteCount = data
        },
        HidePaginBtn(state, data) {
            state.hidePaginBtn = data
        },
        formsData(state, data) {
            state.forms = data
        },
        // MOBILE MUTATIONS
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        Open_form_Consult(state, data) {
            state.isOpenFormConsult = data
        },
        Open_form_SignUp_Project(state, data) {
            state.isOpenFormSignUpProject = data
        },
        getFormConsultData(state, data) {
            state.formConsultData = data
        },
        removePageLoaderImg() {
            var loader = document.getElementById('loader');
            if (loader != undefined) {
                setTimeout(()=>{
                    loader.classList.remove("InitLoader");
                    setTimeout(() => {
                        loader.remove();
                    }, 1000)
                }, 1500);
            }
        },
    }
})
